(function () {
  // Conflict pairs (2026-09-30): client split off some incompatible
  // Build Limitless® products into a new "Build Limitless" vendor (no ®).
  // Keep this in sync with snippets/prx-cart-vendor-alert.liquid.
  var CONFLICT_PAIRS = [
    ['Profile®', 'Build Limitless®'],
    ['Build Limitless®', 'Build Limitless']
  ];

  function getVendorConflicts(items) {
    var vendors = [];
    (items || []).forEach(function (item) {
      if (item.vendor && vendors.indexOf(item.vendor) === -1) vendors.push(item.vendor);
    });
    return CONFLICT_PAIRS.filter(function (pair) {
      return pair.every(function (vendor) {
        return vendors.indexOf(vendor) !== -1;
      });
    });
  }

  function updateAlerts(items) {
    var conflict = getVendorConflicts(items).length > 0;
    var message = conflict
      ? 'Your cart contains items from different product lines that aren\'t designed to be used together. Please double-check compatibility before checkout.'
      : '';

    document.querySelectorAll('[data-prx-vendor-alert]').forEach(function (alertEl) {
      alertEl.hidden = !conflict;
      var textEl = alertEl.querySelector('[data-prx-vendor-alert-text]');
      if (textEl) textEl.textContent = message;
    });
  }

  if (window.theme && window.theme.pubsub) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cart && event.cart.items) {
        updateAlerts(event.cart.items);
      }
    });
  }
})();
